import { Component, Injectable } from '@angular/core';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { State } from "../../model/state";

//Servicio para manejo del estado
@Injectable({
    providedIn: 'root'
})
export class StateService {

    //objeto que representa el estado de un examen
    public state: State;

    //objeto para manejar el cronometro
    public deadLine: Date;

    //objeto que representa el tiempo restante del examen
    public timeChrono: any;

    public endTime: Boolean;

    /** define a dodne ir leugo de finalzair el examen */
    public gotoLogin: Boolean

    /** define el tiempo en caso de que xista sesion previa */
    public previousTime: any;

    //constructor de la clase
    constructor() {
        this.state = null;
        this.deadLine = null;
        this.endTime = false;
    }

    public getTimeRemaining(endtime: any) {
        let t = Date.parse(new Date().toString()) - Date.parse(endtime);
        let seconds = Math.floor((t / 1000) % 60);
        let minutes = Math.floor((t / 1000 / 60) % 60);
        let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        let days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    }

}
